function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Carousel from "segments/desktop/core-components/carousel/carousel";
import TabContentComponent from "segments/desktop/tabs/layouts/carousel-tabs/components/tab-content/tab-content-component";
import { CAROUSEL_TAB_CLICKED } from "constants/bigbrain-event-types";
import { trackEvent } from "services/bigbrain-service";
import { useSlidesToShow } from "segments/desktop/tabs/layouts/carousel-tabs/custom-hooks/use-slides-to-show";
import TabsLabelsComponent from "./components/tabs-labels/tabs-labels-component";
import { StyledCarouselTabsComponent } from "./carousel-tabs-component.scss";
export const CAROUSEL_SETTINGS = {
    defaultIndex: 0,
    infinite: false,
    centerMode: false,
    swipe: false,
    draggable: false,
    dots: false
};
const CarouselTabsComponent = ({ tabs, transitionTime, progressbarColor, tabAdvancedConfig, isInView, containerGap, tabLabelHeight, autoPlayWhenVisible, advancedAssetProps })=>{
    const slidesToShow = useSlidesToShow();
    const slider = useRef(null);
    const parsedTransitionTime = parseInt(transitionTime);
    const [selectedTab, setSelectedTab] = useState(0);
    const labels = useMemo(()=>tabs === null || tabs === void 0 ? void 0 : tabs.map((tab)=>tab.tabLabel), [
        tabs
    ]);
    const slides = useMemo(()=>tabs === null || tabs === void 0 ? void 0 : tabs.map((tab)=>tab.tabContent), [
        tabs
    ]);
    const onSelectionChanges = useCallback((index)=>{
        setSelectedTab(index);
        trackEvent(CAROUSEL_TAB_CLICKED, {
            info1: index + 1
        });
    }, []);
    useEffect(()=>{
        if (!parsedTransitionTime || autoPlayWhenVisible && !isInView) return;
        const interval = setInterval(()=>{
            setSelectedTab((selectedTab + 1) % (tabs === null || tabs === void 0 ? void 0 : tabs.length));
        }, parsedTransitionTime);
        return ()=>{
            clearInterval(interval);
        };
    }, [
        tabs === null || tabs === void 0 ? void 0 : tabs.length,
        parsedTransitionTime,
        isInView,
        autoPlayWhenVisible,
        selectedTab
    ]);
    useEffect(()=>{
        slider === null || slider === void 0 ? void 0 : slider.current.scrollToSlide(selectedTab);
    }, [
        selectedTab
    ]);
    const tabRenderer = useCallback((item)=>/*#__PURE__*/ _jsx(TabContentComponent, _object_spread_props(_object_spread({}, item), {
            tabAdvancedConfig: tabAdvancedConfig,
            advancedAssetProps: advancedAssetProps
        })), [
        advancedAssetProps,
        tabAdvancedConfig
    ]);
    const onSlideChange = (index)=>{
        const didChangedByClick = index !== selectedTab;
        if (didChangedByClick) {
            setSelectedTab(index);
            trackEvent(CAROUSEL_TAB_CLICKED, {
                info1: index + 1
            });
        }
    };
    return /*#__PURE__*/ _jsx(StyledCarouselTabsComponent, {
        containerGap: containerGap,
        className: "carousel-tabs-component",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "carousel-tabs-container",
            children: [
                /*#__PURE__*/ _jsx(TabsLabelsComponent, {
                    tabLabelHeight: tabLabelHeight,
                    slidesToShow: slidesToShow,
                    selectedLabelIndex: selectedTab,
                    transitionTime: autoPlayWhenVisible && !isInView ? null : parsedTransitionTime,
                    onSelectionChanges: onSelectionChanges,
                    progressbarColor: progressbarColor,
                    labels: labels
                }),
                /*#__PURE__*/ _jsx(Carousel, _object_spread({
                    onChange: onSlideChange,
                    slidesToShow: slidesToShow,
                    itemRenderer: tabRenderer,
                    items: slides,
                    ref: slider
                }, CAROUSEL_SETTINGS))
            ]
        })
    });
};
export default CarouselTabsComponent;
